/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDocumentApprovalStatusViewModel } from "../types/AssociatedCompanyDocumentApprovalStatusViewModel.ts";

export const associatedCompanyDocumentApprovalStatusViewModelSchema = z.object({
  attachmentId: z
    .number()
    .int()
    .describe(
      "ID do anexo; nulo quando o aluno não anexou o documento (modelo default). Opcional.",
    )
    .nullish(),
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  associatedCompanyDocumentId: z.optional(
    z.number().int().describe("ID do documento de empresa associada (tipo)."),
  ),
  description: z
    .string()
    .describe('Descrição do anexo; "DEFAULT" no modelo default.')
    .nullish(),
  path: z
    .string()
    .describe("Caminho do arquivo no storage. Opcional.")
    .nullish(),
  url: z
    .string()
    .describe(
      "URL SAS do arquivo para exibição inline no front; nula quando não há arquivo. Opcional.",
    )
    .nullish(),
  isPdf: z.optional(
    z.boolean().describe("Indica se o arquivo é PDF (extensão)."),
  ),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do anexo. Opcional.")
    .nullish(),
  hasCourseIRI: z.optional(
    z.boolean().describe("Indica se o anexo pertence a curso IRI."),
  ),
  documentationStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status agrupado do documento (todos os anexos do tipo). Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
      ),
  ),
  documentationStatusText: z
    .string()
    .describe("Descrição do status agrupado (pt-BR).")
    .nullish(),
  analysisStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status do reconhecimento automático do anexo. Enum EAnalysisStatus: `0` = Recognized, `1` = NotRecognized, `2` = SentToAnalysis, `3` = NotAnalyzed.",
      ),
  ),
  analysisStatusText: z
    .string()
    .describe("Descrição do status do reconhecimento automático (pt-BR).")
    .nullish(),
  hasAnalysisStatus: z.optional(
    z
      .boolean()
      .describe(
        "Indica presença de registro de reconhecimento automático (RG).",
      ),
  ),
}) as unknown as ToZod<AssociatedCompanyDocumentApprovalStatusViewModel>;
